import { Modal, ModalCloseButton, ModalContent } from '@uikit';

import { useRateLimited } from '@shared/common/providers/GlobalModalsProvider';

const RateLimitedModal = () => {
  const rateLimitedModal = useRateLimited();

  return (
    <Modal {...rateLimitedModal.props}>
      <ModalContent className="text-center flex flex-col items-center p-6 sm:p-8">
        <ModalCloseButton className="!ml-auto" />
        <h2 className="text-2xl font-semibold mb-4">Busy Times!</h2>

        <p className="my-8">
          Our system is currently quite busy.
          <br />
          Please wait a few minutes before trying again, and thank you for your understanding.
        </p>
        <button
          type="button"
          className="button button-primary button-lg w-full"
          onClick={rateLimitedModal.close}
        >
          OK
        </button>
      </ModalContent>
    </Modal>
  );
};

export default RateLimitedModal;
